<template>
  <div class="animated fadeIn">
    <p class="text-info">Dashboard page</p>
  </div>
</template>

<script>
export default {
  name: 'dashboard'
}
</script>



// WEBPACK FOOTER //
// src/admin/views/Dashboard.vue